import { CoursePlayer } from "./Components/index";
import { CourseSidebar } from "./Components/index";
import { Loader } from "../../Components/Common";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { CourseDetails } from "./Components/index";
import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useCourses } from "./Hooks/useCourses";

const CourseDetailsPage = () => {
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [modules, setModules] = useState([]);
  const { loading, fetchCourseById } = useCourses();
  const [activeModuleId, setActiveModuleId] = useState(null);
  const { courseId } = useParams();
  const [renderCourse, setRenderCourse] = useState(false);

  function handleReturnToCourse() {
    navigate(-1);
  }

  useEffect(() => {
    fetchCourseById(courseId)
      .then((data) => {
        setCourse(data);
        setModules(data.modules || []);
        setActiveModuleId((prev) =>
          prev && data.modules.some((m) => m.id === prev)
            ? prev
            : (data.modules?.[0]?.id ?? null),
        );
      })
      .catch((err) => {
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      });
  }, [courseId, renderCourse]);

  const activeIndex = modules.findIndex((m) => m.id === activeModuleId);

  const markModuleCompletedInList = (moduleId) => {
    setModules((prev) =>
      prev.map((m) => (m.id === moduleId ? { ...m, is_completed: true } : m)),
    );
  };
  const hasPrev = activeIndex > 0;
  const hasNext = activeIndex < modules.length - 1;

  const completedCount = modules.filter((m) => m.is_completed).length;

  const goPrev = () => {
    if (hasPrev) setActiveModuleId(modules[activeIndex - 1].id);
  };

  const goNext = () => {
    if (hasNext) setActiveModuleId(modules[activeIndex + 1].id);
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-full">
        <Loader />
      </div>
    );

  return (
    <div className="px-4 md:px-4 md:py-2 w-ful mb-6">
      {/* HEADER SECTION  */}
      <div className="flex justify-between mb-2">
        <div className="flex items-center gap-2">
          <button onClick={handleReturnToCourse}>
            <ArrowLeft size={18} className="text-primary" />
          </button>
          <h2 className="text-lg font-semibold text-primary">
            {"View Course"}
          </h2>
        </div>
      </div>

      {/* CONTENT SECTION  */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* COURSE INFO */}
        <div className="lg:col-span-3 h-full">
          <div className="bg-white rounded-lg shadow p-4 h-full ">
            <h2 className="text-lg font-semibold">Course Details</h2>
            <CourseDetails
              course={course}
              completed={completedCount}
              total={modules.length}
            />
          </div>
        </div>

        {/*  MAIN PLAYER */}
        <div className="lg:col-span-6">
          <CoursePlayer
            onPrev={goPrev}
            onNext={goNext}
            hasPrev={hasPrev}
            hasNext={hasNext}
            courseId={courseId}
            moduleId={activeModuleId}
            onCompleted={async (moduleId) => {
              markModuleCompletedInList(moduleId);
              setRenderCourse(!renderCourse);
            }}
          />
        </div>
        {/*  SIDEBAR */}
        <div className="lg:col-span-3 overflow-hidden h-full  ">
          <CourseSidebar
            modules={modules}
            activeModuleId={activeModuleId}
            onSelect={setActiveModuleId}
          />
        </div>
      </div>
    </div>
  );
};

export default CourseDetailsPage;
